<div class="news-item-skeleton"
     [class.w-100]="fullWidth()"
     [ngClass]="type()"
     [ngSwitch]="type()">

  <!-- ===== HORIZONTAL: icona quadrata a sx + testo a dx ===== -->
  <ng-container *ngSwitchCase="'horizontal'">
    <div class="skeleton-block image image--square shimmer"></div>

    <div class="content">
      <div class="skeleton-block line line--title shimmer"></div>
      <div class="skeleton-block line line--title shimmer"></div>
      <div class="skeleton-block line line--title short shimmer"></div>
      <div class="skeleton-block line line--link shimmer"></div>
    </div>
  </ng-container>

  <!-- ===== VERTICAL: immagine larga in alto + testo sotto ===== -->
  <ng-container *ngSwitchCase="'vertical'">
    <div class="skeleton-block image image--wide shimmer"></div>

    <div class="content">
      <div class="skeleton-block line line--title shimmer"></div>
      <div class="skeleton-block line line--title shimmer"></div>
      <div class="skeleton-block line line--title short shimmer"></div>
      <div class="skeleton-block line line--link shimmer"></div>
    </div>
  </ng-container>

</div>
